import React from "react"
import { css } from "emotion"

export interface JamButtonProps {
	jamTime: boolean
	toggleJamMode: () => void
}

export default function JamButton(props: JamButtonProps) {
	return (
		<div
			onClick={props.toggleJamMode}
			className={css`
				width: 60px;
				height: 60px;
				border-radius: 50px;
				position: fixed;
				bottom: 2rem;
				right: 2rem;
				box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
				display: flex;
				align-items: center;
				justify-content: center;
				z-index: 1;
				transition: all 0.4s ease-in-out;
				background: #f8f9fb;
				cursor: pointer;
				font-size: 14px;
				z-index: 1000000;

				${props.jamTime &&
				css`
					background: linear-gradient(
							0deg,
							rgba(115, 229, 191, 0.2),
							rgba(115, 229, 191, 0.2)
						),
						#ffffff;
				`}
			`}
		>
			<img
				src="https://strawberryjam.nyc3.cdn.digitaloceanspaces.com/icon.png"
				className={css`
					width: 30px;
					height: 30px;
				`}
			/>
		</div>
	)
}
